import { Component, Inject, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CORE_CONFIGURATION, IConfigurationVM, ILoggedinUserVM, LogoutService, ScriptService, StorageService } from '@pm-ui/core-services';
import { BnNgIdleService } from 'bn-ng-idle';

@Component({
  selector: 'pm-ui-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'pm-ui';
  currentUser!: ILoggedinUserVM | null;
  userToken:any;
 // logoutNotificationTime: number = 3600;
  constructor(
    @Inject(CORE_CONFIGURATION) private configurationVM: IConfigurationVM, private router: Router,
    private scriptService: ScriptService,
    private renderer2: Renderer2,
    private logoutService: LogoutService,
    private storageService: StorageService,
    private bnIdle: BnNgIdleService,public dialog: MatDialog) {
    this.userToken = this.storageService.getAccessToken();
    if (this.userToken == null || this.userToken == undefined){
     // this.onLogout();
    }
    //const url = `https://maps.googleapis.com/maps/api/js?key=${this.configurationVM.placesApiKey}&libraries=places&language=en`;
    //this.scriptService.registerScript(this.renderer2, url);

    // this.bnIdle.startWatching(this.logoutNotificationTime).subscribe((res: boolean) => {
    //   if (res) {     
    //    var token = this.storageService.getAccessToken();
    //     if (token != null){
    //        //this.matDialog.closeAll();
    //       // localStorage.clear();
    //        //this.logoutService.performLogout();
    //        this.dialog.closeAll();
    //        this.router.navigate(['/']);                                 
    //     }
    //   }
    // })
  }

  onLogout() {
    this.logoutService.performLogout();
    this.router.navigate(['/']);
  }

}

